
/* eslint no-param-reassign: 0 */

export const updateResetPasswordSuccessMessage = ($, payload) => {
  $.resetPasswordSuccessMessage = payload;
};


export default 'bar';



// WEBPACK FOOTER //
// ./src/store-methods/mutations/log-in.js